import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import KeywordSearch from './components/KeywordSearch/KeywordSearch.index';
import FilterPanel from './components/FilterPanel/FilterPanel.index';
import ShopListView from './components/ShopListView/ShopListView.index';
import MyPageLayout from '../../components/Layouts/MyPage/MyPageLayout.index';
import * as actions from '../../store/actions/shopList/shopListActions';
import { RootState } from '../../store/reducers';
import { SCHEDULE_DISPATCH } from '../../store/actions';

const ShopList: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { searchParams, filters, shops, totalCount, loading, loaded, areaOptions, facilityOptions, serviceOptions } =
    useSelector((state: RootState) => state.shopList);

  const pad = (n: number) => n.toString().padStart(2, '0');
  const JST_OFFSET = 9 * 60 * 60 * 1000;
  const getJSTDate = (date?: Date) => {
    const base = date ? date.getTime() : Date.now();
    return new Date(base + JST_OFFSET);
  };
  const targetDate: Date = getJSTDate();
  const yyyy = targetDate.getUTCFullYear();
  const mm = pad(targetDate.getUTCMonth() + 1);
  const dd = pad(targetDate.getUTCDate());
  const todayStr = `${yyyy}${mm}${dd}`;

  useEffect(() => {
    dispatch(actions.fetchShopsInitial());
    dispatch(actions.getVisitorClubOptionsListRequest());
  }, [dispatch]);

  useEffect(() => {
    if (loaded) {
      console.log(shops);
    }
  }, [loaded]);

  const handleKeywordSearch = (params: { area: string; keyword: string }) => {
    dispatch(
      actions.setSearchParams({
        area: params.area,
        keyword: params.keyword.replace(/\s+/g, ' ').trim(),
      }),
    );
    dispatch(actions.fetchShopsRequest());
  };

  const handleFilterChange = (newFilters: typeof filters) => {
    dispatch(actions.setFilters(newFilters));
    dispatch(actions.fetchShopsRequest());
  };

  const handleApplyFilter = () => {
    dispatch(actions.fetchShopsRequest());
  };

  const handleClearFilter = () => {
    dispatch(actions.clearFilters());
    dispatch(actions.fetchShopsRequest());
  };

  const handleReserve = (club: any) => {
    const imageDateP = club.preOpenDay || null;
    dispatch({
      type: SCHEDULE_DISPATCH,
      clubId: club.club_id,
      imageDate: imageDateP != null && imageDateP > todayStr ? imageDateP : todayStr,
    });

    history.push('/reservation/schedule');
  };

  const getSearchConditionText = () => {
    if (searchParams.area) {
      const area = areaOptions.find((a) => a.id === searchParams.area);
      if (area) {
        return area.name;
      }
    }

    if (searchParams.keyword) {
      return searchParams.keyword;
    }

    return '';
  };

  return (
    <MyPageLayout>
      <div className="css-fcftey">
        <section className="p-title-area p-title-area--padding-bottom65">
          <p className="c-title u-text-center">
            ご希望の店舗を
            <br className="u-sp-only" />
            選択してください
          </p>
        </section>

        <section
          className="p-content-area p-content-area--width992 p-content-area--padding-x0-b200 u-gap50 u-sp-gap30"
          style={{ maxWidth: '992px', width: '100%', marginInline: 'auto' }}
        >
          <p className="c-read">
            検索条件で選択、指定した項目は
            <br className="u-sp-only" />
            すべてに当てはまる店舗が表示されます。
          </p>

          <div className="p-content-area__column u-gap30 u-sp-gap25">
            <KeywordSearch areaOptions={areaOptions} onSearch={handleKeywordSearch} />

            <FilterPanel
              isMobile
              facilityOptions={facilityOptions}
              serviceOptions={serviceOptions}
              filters={filters}
              onFilterChange={handleFilterChange}
              onApply={handleApplyFilter}
              onClear={handleClearFilter}
            />

            {loading ? (
              <div className="text-center">読み込み中...</div>
            ) : loaded ? (
              <ShopListView
                shops={shops}
                searchCondition={getSearchConditionText()}
                totalCount={totalCount}
                facilityOptions={facilityOptions}
                serviceOptions={serviceOptions}
                filters={filters}
                onFilterChange={handleFilterChange}
                onApplyFilter={handleApplyFilter}
                onClearFilter={handleClearFilter}
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onBookmark={() => {}}
                onReserve={handleReserve}
              />
            ) : (
              <></>
            )}
          </div>
        </section>
      </div>
    </MyPageLayout>
  );
};

export default ShopList;
